import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[controlErrorContainer]',
    standalone: false
})
export class ControlErrorContainerDirective {

  constructor(public vcr: ViewContainerRef) { }

}
